export default __webpack_public_path__ + "static/media/sipimg.e98af295.png";